import { render, staticRenderFns } from "./TopDecimalAmount.vue?vue&type=template&id=e5dbe100&scoped=true"
import script from "./TopDecimalAmount.vue?vue&type=script&lang=js"
export * from "./TopDecimalAmount.vue?vue&type=script&lang=js"
import style0 from "./TopDecimalAmount.vue?vue&type=style&index=0&id=e5dbe100&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5dbe100",
  null
  
)

export default component.exports